<meta http-equiv="Content-Security-Policy" content="style-src 'self' https://fonts.googleapis.com; font-src 'self' https://fonts.gstatic.com;">

<div *ngFor="let chart of chartInfos; let i = index; let last = last;" style="margin-bottom: 20px;">

    <div *ngIf="!minimal" style="display: flex; align-items: center; margin-top: 10px; margin-bottom: 10px; flex-wrap: wrap; gap: 6px;">
        <label style="font-weight: 500; margin-left: 10px;">Chart Type: </label>
        <select [(ngModel)]="echartType" name="{{'EchartType' + i}}" (ngModelChange)="onEchartTypeChange()">
            <option *ngFor="let t of echartTypes" [value]="t.value">{{ t.label }}</option>
        </select>

        <!-- Per-series chart types (standard time chart only). Right-clicking a series opens a quick menu. -->
        <a *ngIf="seriesTypeOverridesApplicable" class="series-type-link" (click)="openSeriesTypesModal()"
           title="Chart type per series (or right-click a series on the chart)">
            <i class="fas fa-sliders-h"></i><span *ngIf="seriesTypeOverrideCount > 0" class="series-type-count">{{ seriesTypeOverrideCount }}</span>
        </a>

        <ng-container *ngIf="echartType === 'candlestick'">
            <label style="margin-left: 15px;">Group By: </label>
            <select [(ngModel)]="candlestickBucket" name="{{'CandlestickBucket' + i}}" (ngModelChange)="onCandlestickBucketChange()">
                <option *ngFor="let b of candlestickBuckets" [value]="b.value">{{ b.label }}</option>
            </select>
        </ng-container>

        <ng-container *ngIf="showLineXModePicker">
            <label style="margin-left: 15px;">X-Axis: </label>
            <select [(ngModel)]="lineXMode" name="{{'LineXMode' + i}}" (ngModelChange)="onLineXModeChange()">
                <option *ngFor="let m of availableLineXModes" [value]="m.value">{{ m.label }}</option>
            </select>
        </ng-container>

        <ng-container *ngIf="showPolarBucketPicker">
            <label style="margin-left: 15px;">Direction Bucket: </label>
            <select [(ngModel)]="polarBucketDegrees" name="{{'PolarBucket' + i}}" (ngModelChange)="onPolarBucketChange()">
                <option *ngFor="let b of polarBuckets" [ngValue]="b.value">{{ b.label }}</option>
            </select>
        </ng-container>

        <ng-container *ngIf="showScatterAxisPickers">
            <label style="margin-left: 15px;">X-Axis: </label>
            <ng-select [items]="scatterXOptions"
                       [multiple]="true"
                       [closeOnSelect]="false"
                       appendTo="body"
                       placeholder="Select X series"
                       name="{{'ScatterX' + i}}"
                       [(ngModel)]="scatterXSeries"
                       (ngModelChange)="onScatterSeriesChange()"
                       style="width: 220px;">
            </ng-select>

            <label style="margin-left: 15px;">Y-Axis: </label>
            <ng-select [items]="availableSeriesNames"
                       [multiple]="true"
                       [closeOnSelect]="false"
                       appendTo="body"
                       placeholder="Select Y series"
                       name="{{'ScatterY' + i}}"
                       [(ngModel)]="scatterYSeries"
                       (ngModelChange)="onScatterSeriesChange()"
                       style="width: 220px;">
            </ng-select>
        </ng-container>

        <label *ngIf="echartType !== 'candlestick' && sensorReadingTypes && sensorReadingTypes.length > 1"
               style="margin-left: 15px;">
            <input type="checkbox" [(ngModel)]="overlayIndependentYAxis" name="{{'OverlayIndependentYAxis' + i}}" (ngModelChange)="onOverlayIndependentYAxisChange()" style="margin-right: 5px; vertical-align: middle;" />
            Overlay Independent Y-Axis
        </label>

        <span class="control-group-header" style="margin-left: 15px;" (click)="toggleGroup('outliers', i)"
              title="Show / hide the ignore-outlier bounds">
            <label style="font-weight: 500; font-size: 14px;">Ignore Outliers</label>
            <i class="fas" [ngClass]="isGroupExpanded('outliers', i) ? 'fa-chevron-down' : 'fa-chevron-right'" style="margin-top: 3px;"></i>
        </span>

        <ng-container *ngIf="isGroupExpanded('outliers', i)">
            <label style="font-size: 13px;">Values < </label>
            <input type="text" id="{{'yMinIgnore' + instanceId + '_' + i}}" name="{{'yMinIgnore' + i}}" size=7 [(ngModel)]="chart.yMinIgnore" (keyup.enter)="onPerChartOptionChange()" required />
            <div class="fas fa-sync-alt" (click)="onPerChartOptionChange()" style="cursor: pointer; color: rgb(0, 123, 255); margin-right: 10px;"></div>

            <label style="font-size: 13px;">Values > </label>
            <input type="text" id="{{'yMaxIgnore' + instanceId + '_' + i}}" name="{{'yMaxIgnore' + i}}" size=7 [(ngModel)]="chart.yMaxIgnore" (keyup.enter)="onPerChartOptionChange()" required />
            <div class="fas fa-sync-alt" (click)="onPerChartOptionChange()" style="cursor: pointer; color: rgb(0, 123, 255);"></div>
        </ng-container>

        <ng-container *ngIf="sensors && sensors.length > 0 && echartType !== 'polar'">
            <span class="control-group-header" style="margin-left: 20px;" (click)="toggleGroup('aggregates', i)"
                  title="Show / hide the aggregate series options">
                <label style="font-weight: 500; font-size: 14px;">Aggregate Series</label>
                <i class="fas" [ngClass]="isGroupExpanded('aggregates', i) ? 'fa-chevron-down' : 'fa-chevron-right'" style="margin-top: 3px;"></i>
            </span>

            <ng-container *ngIf="isGroupExpanded('aggregates', i)">
                <select *ngIf="showAggregateGroupPicker" [(ngModel)]="aggregateGroupMode" name="{{'AggregateGroupMode' + i}}" (ngModelChange)="onPerChartOptionChange()"
                        title="Aggregate across all selected sensors, or separately for each sensor group"
                        style="font-size: 13px; margin-right: 10px;">
                    <option *ngFor="let m of aggregateGroupModes" [value]="m.value">{{ m.label }}</option>
                </select>

                <label *ngIf="sensors.length > 1 || isMinOfDayActive" style="font-size: 13px; margin-right: 10px;">
                    <input type="checkbox" name="{{'showAverage' + i}}" [(ngModel)]="chart.showAverage" (ngModelChange)="onPerChartOptionChange()" style="margin-top: -3px; vertical-align: middle;" />
                    Average
                </label>

                <label *ngIf="sensors.length > 1 || isMinOfDayActive" style="font-size: 13px; margin-right: 10px;">
                    <input type="checkbox" name="{{'showMedian' + i}}" [(ngModel)]="chart.showMedian" (ngModelChange)="onPerChartOptionChange()" style="margin-top: -3px; vertical-align: middle;" />
                    Median
                </label>

                <label *ngIf="sensors.length > 1 || isMinOfDayActive" style="font-size: 13px; margin-right: 10px;">
                    <input type="checkbox" name="{{'showTrimmedMean' + i}}" [(ngModel)]="chart.showTrimmedMean" (ngModelChange)="onPerChartOptionChange()" style="margin-top: -3px; vertical-align: middle;" />
                    Trimmed-Mean
                </label>

                <label *ngIf="!isMinOfDayActive" style="font-size: 13px; margin-right: 10px;">
                    <input type="checkbox" name="{{'showSum' + i}}" [(ngModel)]="chart.showSum" (ngModelChange)="onPerChartOptionChange()" style="margin-top: -3px; vertical-align: middle;" />
                    Sum
                </label>
            </ng-container>
        </ng-container>

        <ng-container *ngIf="dailySeriesApplicable && sensors && sensors.length > 0">
            <span class="control-group-header" style="margin-left: 20px;" (click)="toggleGroup('daily', i)"
                  title="Show / hide the daily series options">
                <label style="font-weight: 500; font-size: 14px;">Daily Series</label>
                <i class="fas" [ngClass]="isGroupExpanded('daily', i) ? 'fa-chevron-down' : 'fa-chevron-right'" style="margin-top: 3px;"></i>
            </span>

            <ng-container *ngIf="isGroupExpanded('daily', i)">
                <select [(ngModel)]="dailyGroupMode" name="{{'DailyGroupMode' + i}}" (ngModelChange)="onPerChartOptionChange()"
                        title="Compute the daily statistic across all selected sensors, per sensor group, or per individual sensor"
                        style="font-size: 13px; margin-right: 10px;">
                    <option *ngFor="let m of dailyGroupModeOptions" [value]="m.value">{{ m.label }}</option>
                </select>

                <label style="font-size: 13px; margin-right: 10px;">
                    <input type="checkbox" name="{{'showDailyAverage' + i}}" [(ngModel)]="chart.showDailyAverage" (ngModelChange)="onPerChartOptionChange()" style="margin-top: -3px; vertical-align: middle;" />
                    Average
                </label>

                <label style="font-size: 13px; margin-right: 10px;">
                    <input type="checkbox" name="{{'showDailyMedian' + i}}" [(ngModel)]="chart.showDailyMedian" (ngModelChange)="onPerChartOptionChange()" style="margin-top: -3px; vertical-align: middle;" />
                    Median
                </label>

                <label style="font-size: 13px; margin-right: 10px;">
                    <input type="checkbox" name="{{'showDailyTrimmedMean' + i}}" [(ngModel)]="chart.showDailyTrimmedMean" (ngModelChange)="onPerChartOptionChange()" style="margin-top: -3px; vertical-align: middle;" />
                    Trimmed-Mean
                </label>

                <label style="font-size: 13px; margin-right: 10px;">
                    <input type="checkbox" name="{{'showDailyMin' + i}}" [(ngModel)]="chart.showDailyMin" (ngModelChange)="onPerChartOptionChange()" style="margin-top: -3px; vertical-align: middle;" />
                    Min
                </label>

                <label style="font-size: 13px; margin-right: 10px;">
                    <input type="checkbox" name="{{'showDailyMax' + i}}" [(ngModel)]="chart.showDailyMax" (ngModelChange)="onPerChartOptionChange()" style="margin-top: -3px; vertical-align: middle;" />
                    Max
                </label>

                <label style="font-size: 13px; margin-right: 10px;">
                    <input type="checkbox" name="{{'showDailySum' + i}}" [(ngModel)]="chart.showDailySum" (ngModelChange)="onPerChartOptionChange()" style="margin-top: -3px; vertical-align: middle;" />
                    Sum
                </label>
            </ng-container>
        </ng-container>

        <span class="control-group-header" style="margin-left: 15px;" (click)="toggleGroup('colors', i)"
              title="Show / hide the series color palette">
            <label style="font-weight: 500; font-size: 14px;">Colors</label>
            <i class="fas" [ngClass]="isGroupExpanded('colors', i) ? 'fa-chevron-down' : 'fa-chevron-right'" style="margin-top: 3px;"></i>
        </span>

        <span *ngIf="isGroupExpanded('colors', i)" style="display: inline-flex; align-items: center; gap: 4px;">
            <input *ngFor="let color of colorScheme; let ci = index; trackBy: trackByIndex"
                   type="color"
                   [value]="color"
                   (change)="onPaletteColorChange(ci, $any($event.target).value)"
                   title="Series color {{ ci + 1 }}"
                   style="width: 22px; height: 22px; padding: 0; border: 1px solid #ccc; cursor: pointer;" />
            <button type="button" class="btn btn-sm btn-outline-secondary" style="font-size: 12px; padding: 2px 8px; margin-left: 4px;" (click)="addPaletteColor()" title="Add a color to the palette">+</button>
            <button type="button" class="btn btn-sm btn-outline-secondary" style="font-size: 12px; padding: 2px 8px;" (click)="resetColorScheme()" title="Reset to the default 5 colors">Reset Colors</button>
        </span>

        <!-- Add/Edit labels (standard combined time charts only). Pinned right. -->
        <span *ngIf="labelsEditable && annotationsApplicable" style="margin-left: auto; padding-left: 15px;">
            <button type="button" class="btn btn-sm"
                    [class.btn-success]="labelsEditMode" [class.btn-outline-success]="!labelsEditMode"
                    style="font-size: 12px; padding: 2px 8px;" (click)="toggleLabelEditing()">
                {{ labelsEditMode ? 'Done Editing Labels' : 'Labels' }}
            </button>
        </span>

        <!-- Last in the row with margin-left:auto so the legend actions stay pinned
             to the right edge no matter how many controls are expanded. -->
        <span *ngIf="showLegend" style="margin-left: auto; padding-left: 15px;">
            <button type="button" class="btn btn-sm btn-outline-secondary" style="font-size: 12px; padding: 2px 8px;" (click)="legendSelectAll(i)">Select All</button>
            <button type="button" class="btn btn-sm btn-outline-secondary" style="font-size: 12px; padding: 2px 8px; margin-left: 6px;" (click)="legendUnselectAll(i)">Unselect All</button>
        </span>
    </div>

    <div id="{{'echartContainer' + instanceId + '_' + i}}" class="echart-container" [style.background-color]="darkBackground ? '#222222' : '#ffffff'" style="font-weight: 500;">
        <div echarts
            class="echart"
            [style.height]="fillHeight ? null : chartHeight"
            [options]="chartOptions[i]"
            [autoResize]="true"
            (chartInit)="onChartInit(i, $event)"
            (chartClick)="onChartClick(i, $event)"
            (chartDataZoom)="onChartDataZoom(i, $event)"
            (chartLegendSelectChanged)="onLegendSelectChanged(i, $event)"
            (chartContextMenu)="onChartContextMenu(i, $event)">
        </div>

        <!-- Right-click menu to pick the clicked series' chart type. -->
        <div *ngIf="seriesMenu && i === 0" class="series-type-menu" [class.dark]="darkBackground"
             [style.left.px]="seriesMenu.x" [style.top.px]="seriesMenu.y" (click)="$event.stopPropagation()">
            <div class="series-type-menu-title" [title]="seriesMenu.name">{{ seriesMenu.name }}</div>
            <div *ngFor="let t of seriesChartTypes" class="series-type-menu-item" (click)="setSeriesType(seriesMenu.name, t.value)">
                <i class="fas fa-check" [style.visibility]="(seriesTypeOverrides[seriesMenu.name] === t.value) ? 'visible' : 'hidden'"></i> {{ t.label }}
            </div>
            <div class="series-type-menu-item series-type-menu-reset" (click)="setSeriesType(seriesMenu.name, null)">
                <i class="fas fa-check" [style.visibility]="seriesTypeOverrides[seriesMenu.name] == undefined ? 'visible' : 'hidden'"></i> Use chart default
            </div>
        </div>
    </div>

    <hr *ngIf="!last">
</div>
